<template>
  <div class="placeAnOrder">

    <div class="userinfo cfff">
      <div>
        <div class="font40 fontbold">{{ userInfo.userName }}</div>
        <div class="font28">{{ userInfo.userPhone }}</div>
      </div>
      <div v-if="balancedata[0]">
        <!-- <img class="userheadImgUrl" :src="userInfo.headImgUrl" /> -->
        <div class="font24 cantext">可用余额(元)</div>
        <div class="fontbold font60">{{ balancedata[0].balance }}</div>
      </div>
    </div>

    <div class="orderinfo">
      <div class="cabinet" @click="choiceCabinet()">
        <div class="input-title redDot font28 mt20 c000"></span> 钥匙柜</div>
        <div class="cabinetdata">
          <div class="font28 c999">{{ cabdataText }}</div>
          <van-icon name="arrow" color="#999" />
        </div>
      </div>

      <div class="cabinet">
        <div class="input-title redDot font28 mt20 c000"></span> 客户车辆</div>
        <div class="platelist">
          <div class="addplate" :class="item == orderParams.number ? 'addplateon' : ''" v-for="item in numberPlates"
            @click="selectNumber(item)">{{ item }}</div>
          <div class="addplate" @click="addPlate()">
            <van-icon name="add-o" size="0.4rem" />
          </div>
        </div>
      </div>

      <div class="cabinet" @click="choiceProject()">
        <div class="input-title redDot font28 mt20 c000"></span> 服务项目</div>
        <div class="cabinetdata">
          <div class="font28 c999">{{ servicesText }}</div>
          <van-icon name="arrow" color="#999" />
        </div>
      </div>
      <div class="cabinet" @click="choiceCoupon()">
        <div class="input-title font28 mt20 c000 ml20"></span> 优惠券</div>
        <div class="cabinetdata">
          <div class="font28 c999">{{ couponsText }}</div>
          <van-icon name="arrow" color="#999" />
        </div>
      </div>
      <!-- 最近消费记录 -->
      <div class="cabinet" v-if="orders.length>0">
        <!-- <div class="consumption" v-if="userOrders.length > 0"> -->

        <div class="consumption">
          <div class="conTitle">
            <span class="titlex"></span>
            <div class="ml20 font32 c000">最近消费记录</div>
          </div>
          <div class="consumbody mt20">
            <!-- <div class="consumbodyli" v-for="item in userOrders"> -->
            <div class="consumbodyli" v-for="(item,index) in orders" :key="index">
              <div class="sonName">
                <span class="namelog"></span>
                <!-- <div class="nametext font26 ml10 c000">{{ item.serviceName }}</div> -->
                <div class="nametext font26 ml10 c000">{{ item.serviceName }}</div>
              </div>
              <!-- <div class="contime c000 font24">{{ item.creatTime }}</div> -->
              <div class="contime c000 font24">{{ item.creatTime }}</div>
            </div>

          </div>
        </div>
      </div>
      <!-- <div class="cabinet" v-if="balancedata">
        <div class="input-title redDot font28 mt20 c000 "></span> 扣款方式</div>
        <div class="cabinetdata Deduction">
          <div class="deductype" :class="orderParams.bpId==item.partnerId? 'deductypeon':''" v-for="item in balancedata"  @click="selectBalance(item.partnerId)">
            <div class="font26 c333 dedtext fontbold">{{item.partnerName}}</div>
            <div class="font32 c333 fontbold dedtext">{{item.balance}}</div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="botbtn">
      <div class="font30" v-if="orderParams.goodsIds[0]">{{ settlementText }} <span class="projectmoney ml10 fontbold">
          ¥{{ settlementmoney }}</span> </div>
      <div class="font30" v-else>{{ settlementText }}</div>

      <div class="openorderbtn font36 fontbold c000" @click="openOrder()">开单</div>
    </div>
    <!-- 钥匙柜弹窗 -->
    <van-popup v-model:show="cabinetshow" position="bottom" round :style="{ height: '60%' }" closeable>
      <div class="cabtitle font36 c666 fontbold">附近钥匙柜</div>
      <div class="cabul">
        <div class="cablist " :class="item.cabinetId == orderParams.cabinetId ? 'cabliston' : ''"
          v-for="item in cabdata" @click="selectCabinet(item.cabinetId, item.cabinetName, item.available)">
          <div class="c000 font28 fontbold">{{ item.cabinetName }}</div>
          <div class="state cfff font26" :class="item.available ? '' : 'stateno'">{{ item.statusDesc }}</div>
        </div>
      </div>

    </van-popup>

    <!-- 服务弹窗 -->
    <van-popup v-model:show="projectshow" position="bottom" round :style="{ height: '60%' }" closeable>

      <div class="cabtitle font36 c666 fontbold">本店项目</div>
      <div class="cabul">
        <div class="cablist" :class="item.id == orderParams.id ? 'cabliston' : ''" v-for="item in servicesdata"
          @click="selectServices(item.id, item.name, item.balancePrice)">
          <div class="c000 font28 fontbold">{{ item.name }}</div>
          <div class="projectmoney font36 fontbold">¥{{ item.balancePrice }}</div>
        </div>
      </div>

    </van-popup>

    <!-- 优惠券弹窗 -->
    <van-popup v-model:show="couponshow" position="bottom" round :style="{ height: '60%' }" closeable>

      <div class="cabtitle font36 c666 fontbold">可用优惠券</div>
      <div class="cabul">
        <div class="cablist" :class="item.userCouponsId == orderParams.userCouponsId ? 'cabliston' : ''"
          v-for="item in couponsData" @click="selectCoupons(item.userCouponsId, item.couponsAmount)">
          <div class="c000 font28 fontbold">{{ item.couponsName }}</div>
          <div class="projectmoney font36 fontbold">-{{ item.couponsAmount }}</div>
        </div>
      </div>

    </van-popup>

    <!-- 添加车牌 -->
    <van-dialog v-model:show="addplate" title="添加车牌" show-cancel-button @confirm="addPlateEnter()">
      <input type="text" v-model="addplatenum" class="addplateinput" placeholder="例:陕A88888 (字母无需区分大小写)">
    </van-dialog>

  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  name: 'placeAnOrder', // 开单页面
  data () {
    return {
      up: '', // 二维码参数
      isMember: '', // 用户是否会员
      userInfo: '', // 用户信息
      cabdata: '', // 柜子列表
      cabdataText: '选择钥匙柜', // 钥匙柜文字
      servicesdata: '', // 服务项目列表
      servicesText: '选择服务', // 服务项目文字
      settlementText: '', // 开单按钮左侧文字
      settlementmoney: '', // 选中服务的价格
      couponsData: '', // 优惠券列表
      couponsText: '选择服务后查看优惠券', // 优惠群文字
      cabinetshow: false, // 选择钥匙柜
      projectshow: false, // 服务项目
      addplate: false, // 添加车牌
      couponshow: false, // 优惠券弹窗
      balancedata: '', // 钱包信息
      numberPlates: [], // 车牌列表
      orders: [], // 消费记录
      addplatenum: '', // 新添加车牌
      orderParams: {// 开单信息
        userId: '', // 用户id
        cabinetId: '', // 柜子id
        goodsIds: [], // 服务id
        number: '', // 车牌
        // bpId:'',//支付方式id
        couponsId: ''// 优惠券id
      }
    }
  },
  created () {
    console.log(this.$route.query)
    this.up = this.$route.query.up
    this.getUserInfo()
  },
  mounted () {
    this.getCurrentLocation()
  },

  methods: {
    // 选择钥匙柜
    choiceCabinet () {
      this.cabinetshow = !this.cabinetshow
    },
    // 选择项目
    choiceProject () {
      if (this.orderParams.cabinetId) {
        this.projectshow = !this.projectshow
      } else {
        Toast('请先选择钥匙柜')
      }
    },
    // 选择优惠券
    choiceCoupon () {
      if (this.orderParams.goodsIds.length > 0) {
        this.couponshow = !this.couponshow
      } else {
        Toast('请先选择服务项目')
      }
    },
    // 添加车牌
    addPlate () {
      this.addplate = true
    },
    // 确认添加弹窗
    addPlateEnter () {
      var value = this.addplatenum.replace(/\s*/g, '') // 将输入的内容去掉空格
      value = value.toUpperCase() // 将输入内容中的字母转为大写
      var card = this.isLicensePlate(value)
      for (let i = 0; i <= this.numberPlates.length; i++) {
        if (this.numberPlates[i] == value) {
          Toast('添加车牌已存在')
          return
        }
      }
      if (card == false) {
        Toast('请输入正确的车牌号')
      } else {
        this.$api.HZrequest('/we-chat/gzh/washer/add/userNum', 'POST', { 'userId': this.orderParams.userId, 'number': value }).then((res) => {
          if (res.code == 200) {
            this.numberPlates.push(value)
            this.addplatenum = ''
            this.orderParams.number = value
          }
        })
      }
    },

    // 选中柜子
    selectCabinet (Id, Name, available) { // 柜子id 柜子名称  柜子状态
      // this.orderParams.cabinetId = Id
      // this.cabdataText = Name
      // //关闭弹窗
      // this.choiceCabinet();
      // //根据柜子请求服务
      // this.getAllServices();

      if (available == true) {
        this.orderParams.cabinetId = Id
        this.cabdataText = Name
        // 关闭弹窗
        this.choiceCabinet()
        // 根据柜子请求服务
        this.getAllServices()
      } else {
        Toast('该柜子当前不可选择')
      }
    },
    // 选择项目
    selectServices (Id, Name, Num) {
      this.orderParams.goodsIds = []
      this.orderParams.goodsIds.push(Id)
      this.servicesText = Name
      this.settlementText = Name
      this.settlementmoney = Num
      // 关闭弹窗
      this.choiceProject()
      // 查询优惠券
      this.getUserCoupons()
    },

    // 获取当前位置信息
    getCurrentLocation () {
      var that = this
      var options = {
        timeout: 3000
      }
      var geolocation = new qq.maps.Geolocation('H7XBZ-QF4WK-XNJJ5-AQMFZ-TVASQ-3QF7Q', 'myapp')
      // 定位成功之后调用的方法
      function showPosition (position) {
        let lat = position.lat
        let lng = position.lng
        that.longitude = lng
        // that.longitude=109.039768
        that.latitude = lat
        // that.latitude=37.263335
        // 获取柜子
        that.getNearbyCabinet()
      };

      function showErr () {
        console.log('定位失败')
        Toast('获取位置信息失败')
      }
      geolocation.getLocation(showPosition, showErr, options)
    },
    // 选择支付方式
    // selectBalance(id){
    //   this.orderParams.bpId=id
    // },
    // 选择优惠券
    selectCoupons (id, num) {
      this.orderParams.couponsId = id
      this.couponsText = '-' + num
      this.settlementmoney = this.settlementmoney - num
      if (this.settlementmoney < 0) {
        this.settlementmoney = 0
      }
      this.choiceCoupon()
    },

    // 获取用户信息
    getUserInfo (up) {
      this.$api.HZrequest('/we-chat/gzh/user/qrCode/info', 'GET', { 'up': this.up }).then((res) => {
        if (res.code == 200) {
          this.userInfo = res.data// 用户信息
          this.numberPlates = res.data.numberPlates// 用户车牌
          this.orderParams.userId = res.data.userId// 用户id
          this.orders = res.data.orders// 用户订单
          // this.isMember = res.data.isMember//是否会员
        } else {
          Toast(res.msg)
        }
      })
    },

    // 获取附近钥匙柜子
    getNearbyCabinet () {
      var that = this
      this.$api.HZrequest('/we-chat/gzh/washer/get-available-cabinets', 'POST', { 'longitude': this.longitude, 'latitude': this.latitude }).then((res) => {
        that.cabdata = res.data
      })
    },
    // 获取店面服务项目
    getAllServices () {
      var that = this
      this.$api.HZrequest('/we-chat/gzh/washer/get-all-services', 'GET', { 'cabinetId': this.orderParams.cabinetId, 'userId': this.orderParams.userId }).then((res) => {
        that.servicesdata = res.data.goods
        if (res.data.balance.length > 0) {
          that.balancedata = res.data.balance
        } else {
          this.settlementText = '非会员用户'
        }
      })
    },
    // 获取优惠券
    getUserCoupons () {
      var that = this
      this.$api.HZrequest('/we-chat/gzh/washer/user/coupons', 'POST', { 'userId': this.orderParams.userId, 'goodsIds': this.orderParams.goodsIds }).then((res) => {
        this.couponsData = res.data
        console.log(res.data.length)
        if (res.data.length <= 0) {
          this.couponsText = '暂无优惠券'
        } else if (res.data.length > 0) {
          this.couponsText = '请选择优惠券'
        }
      })
    },
    // 选择车牌
    selectNumber (number) {
      this.orderParams.number = number
    },

    // 下单
    openOrder () {
      var that = this
      console.log(this.orderParams)
      if (this.orderParams.goodsIds.length <= 0) {
        Toast('请选择服务')
        return
      } else if (!this.orderParams.number) {
        Toast('请选择用户车牌')
        return
      }
      this.$api.HZrequest('/we-chat/gzh/washer/valet/order', 'POST', this.orderParams).then((res) => {
        if (res.code == 200) {
          Toast('成功接单')
          setTimeout(function () {
            that.$router.push({
              path: '/service'
            })
          }, 500)
        } else {
          Toast(res.msg)
        }
      })
    },

    // 车牌验证
    // 正则验证车牌,验证通过返回true,不通过返回false
    isLicensePlate (str) {
      return /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(str)
    }

  }

}
</script>

<style>
html,
body {
  height: 100%;
  box-sizing: border-box;
}

.placeAnOrder {
  padding-bottom: 1rem;
}

.userinfo {
  width: 100%;
  height: 1.94rem;
  background: #FF9D2B;
  box-sizing: border-box;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cantext {
  text-align: end;
}

.botbtn {
  width: 100%;
  height: 0.9rem;
  background: #fff;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  align-items: center;
  box-sizing: border-box;
  padding-left: 0.3rem;
}

.openorderbtn {
  width: 2rem;
  height: 100%;
  background: #F7D246;
  position: absolute;
  right: 0;
  bottom: 0;
  text-align: center;
  line-height: 0.9rem;
}

.cabinet {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 0.2rem 0.3rem;
  justify-content: space-between;
}

.redDot:before {
  content: '*';
  color: #FF0000;
}

.cabinetdata {
  width: 5.28rem;
  height: 1.08rem;
  background: #fff;
  border-radius: 0.08rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-right: 0.1rem;
}

.platelist {
  width: 5.28rem;
  background: #fff;
  border-radius: 0.08rem;
  box-sizing: border-box;
  padding: 0.18rem 0.12rem;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 0;
}

.addplate {
  width: 1.6rem;
  height: 0.7rem;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.12rem;
  margin-bottom: 0.12rem;
  box-sizing: border-box;
  border-radius: 0.08rem;
}

.addplateon {
  border: 2px solid #FF9D2B;
}

.addplate:nth-child(3n) {
  margin-right: 0;
}

.cablist {
  width: 6.8rem;
  height: 1rem;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(55, 55, 55, 0.13);
  margin: 0 auto;
  border-radius: 0.1rem;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 0.3rem;
}

.cablist:first-child {
  margin-top: 0.2rem;
}

.cabtitle {
  width: 100%;
  padding: 0.3rem 0rem;
  text-align: center;
  box-sizing: border-box;
  height: 1rem;
  background: #fff;
}

.state {
  width: 1.6rem;
  height: 0.6rem;
  border-radius: 0.28rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #35D757;
}

.stateno {
  background: #BFBFBF;
}

.cabul {
  width: 100%;
  height: calc(100% - 1rem);
  overflow: hidden;
  overflow-y: auto;
}

.cabliston {
  border: 2px solid #FF9D2B;
}

.projectmoney {
  color: #FF9D2B;
}

.userheadImgUrl {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
}

.addplateinput {
  width: 86%;
  height: 0.6rem;
  background: #f5f5f5;
  border-radius: 0.06rem;
  margin: 0.2rem auto;
  display: block;
  padding: 0.1rem;
}

.Deduction {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: none;
}

.deductype {
  padding: 0.1rem 0.3rem;
  border-radius: 0.1rem;
  box-sizing: border-box;
  background: #F5F5F5;
  min-width: 2rem;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(55, 55, 55, 0.13);
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
}

.deductypeon {
  border: 2px solid #FF9D2B;
}

.dedtext {
  width: 100%;
  text-align: center;
}

.openorderbtnno {
  background: #bfbfbf;
}
</style>
<style>
.consumption {
  background: #fff;
  box-sizing: border-box;
  padding: 0.24rem 0.32rem;
  padding-bottom: 0;
  width: 100%;
  border-radius: 10px;
}

.consumption1 {
  padding: 0;
}

.consumption1 .conTitle {
  padding: 0.24rem 0.32rem;
  padding-bottom: 0;
  box-sizing: border-box;
}

.conTitle {
  width: 100%;
  display: flex;
  align-items: center;
}

.titlex {
  height: 0.44rem;
  width: 0.06rem;
  background: #ffd100;
}

.sonName {
  display: flex;
  align-items: center;
}

.namelog {
  border-radius: 50%;
  height: 0.14rem;
  width: 0.14rem;
  background: #ffd100;
}

.consumbodyli {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0.2rem 0.1rem;
  border-bottom: 1px solid #eaeaea;
}

.consumbodyli:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/placeAnOrder.vue